export default __webpack_public_path__ + "static/media/organic-mobile.9e8b6842.jpg";